import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {SharedSettings} from "../models/shared-settings";
import {Cacheable, CacheBuster} from "ts-cacheable";
import {url} from "../helpers/url";
import {Location} from "../models/location";

@Injectable({
    providedIn: 'root'
})
export class LocationService {
    private static readonly cacheObservable = new Subject<void>();

    constructor(private http: HttpClient, private settings: SharedSettings) {
    }

    @Cacheable({
        cacheBusterObserver: LocationService.cacheObservable,
        maxAge: 5 * 60 * 1000
    })
    getAllLocations(): Observable<Location[]> {
        return this.http.get<Location[]>(this.settings.apiBaseUrl + url`locations/all`);
    }

    @CacheBuster({
        cacheBusterNotifier: LocationService.cacheObservable
    })
    updateLocation(location: Location): Observable<Location> {
        return this.http.put<Location>(this.settings.apiBaseUrl + url`locations/${location.id}`, location);
    }

    @CacheBuster({
        cacheBusterNotifier: LocationService.cacheObservable
    })
    createLocation(location: Location): Observable<Location> {
        return this.http.post<Location>(this.settings.apiBaseUrl + url`locations`, location);
    }
}
